import { render } from "./AncestorTreePersonCards.vue?vue&type=template&id=2bfbfa5a&scoped=true"
import script from "./AncestorTreePersonCards.vue?vue&type=script&lang=js"
export * from "./AncestorTreePersonCards.vue?vue&type=script&lang=js"

import "./AncestorTreePersonCards.vue?vue&type=style&index=0&id=2bfbfa5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfbfa5a"]])

export default __exports__